import {Component} from 'react';
import h from 'react-hyperscript';
import './DriveUserProfiles.scss';
import BasicCard from 'Components/Cards/BasicCard';
import {h4, eyebrow, caption} from 'Components/Typography/Typography';
import Image from 'Components/Image/Image';
import MobileMenu from 'Components/MobileMenu/MobileMenu';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import DriveUserProfilesTabContent from './TabContent';
import TabHeader from 'Components/TabHeader/TabHeader';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import {setZeroIfInvalidNumber, isArrayEmpty} from 'Src/utils/utils';
import ReportError from 'Components/ErrorMessage/ReportError';

class DriveUserProfiles extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      activeTab: 0,
      mobileAnchorEl: null,
      userProfiles: null,
      isLoaded: false,
      totalNumUsers: this.props.totalNumUsers,
      totalNumUsersPrev: this.props.totalNumUsersPrev,
      hasError: false,
    };
    this.handleMobileMenuOpen = this.handleMobileMenuOpen.bind(this);
    this.handleMobileMenuClose = this.handleMobileMenuClose.bind(this);
    this.changeContent = this.handleTabClick.bind(this);
    this.createReviewBars = this.createReviewBars.bind(this);
  }

  componentWillMount() {
    this._isMounted = true;
    this.setData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData() {
    if (this.dataAvailable) {
      this.setTotalNumUsers();
    } else {
      this.setHasError(true);
    }
  }

  get dataAvailable() {
    return (
      this.props.hasProductMetricsHistory &&
      !isArrayEmpty(this.props.data) &&
      this.props.totalNumUsers &&
      !isArrayEmpty(this.props.tabs)
    );
  }

  setHasError(value) {
    this.setState({
      isLoaded: true,
      hasError: value,
    });
  }

  getUserProfiles(isPrev) {
    const creators = this.getWeeklyPercentage('creators', isPrev);
    const collaborators = this.getWeeklyPercentage('collaborators', isPrev);
    const sharers = this.getWeeklyPercentage('sharers', isPrev);
    const profiles = [
      {
        title: 'creators',
        weeklyData: creators,
      },
      {
        title: 'sharers',
        weeklyData: sharers,
      },
      {
        title: 'collaborators',
        weeklyData: collaborators,
      },
    ];

    if (this._isMounted) {
      this.setUserProfiles(profiles, isPrev);
    }
  }

  getWeeklyPercentage(type, isPrev) {
    const data = isPrev ? this.props.dataPrev : this.props.data;
    const numUsers = isPrev ?
      this.state.totalNumUsersPrev :
      this.state.totalNumUsers;

    const weeklyValues = data.map((week) => {
      const metric = week[`drive_${type}`];
      return setZeroIfInvalidNumber(metric / numUsers);
    });

    return weeklyValues;
  }

  setTotalNumUsers() {
    const {totalNumUsers, totalNumUsersPrev} = this.props;
    this.setState(
        {
          totalNumUsers,
          totalNumUsersPrev,
        },
        () => {
          this.getUserProfiles();

          if (this.state.totalNumUsersPrev) {
            this.getUserProfiles(true);
          }

          this.setIsLoaded(true);
        }
    );
  }

  setUserProfiles(value, isPrev) {
    const key = 'userProfiles' + (isPrev ? 'Prev' : '');

    this.setState({
      [key]: value,
    });
  }

  setIsLoaded(value) {
    if (this._isMounted) {
      this.setState({
        isLoaded: value,
      });
    }
  }

  setActiveTab(value) {
    this.setState({
      activeTab: value,
    });
  }

  handleTabClick(e) {
    e.preventDefault();
    this.setActiveTab(e.currentTarget.getAttribute('datatab'));
  }

  handleMobileMenuOpen(e) {
    this.setState({
      mobileAnchorEl: e.currentTarget,
    });
  }

  handleMobileMenuClose() {
    this.setState({
      mobileAnchorEl: null,
    });
  }

  createReviewBars(tab, isPrev) {
    if (isPrev && (!this.props.dataPrev || !this.state.userProfilesPrev)) {
      return;
    }
    const userProfiles = isPrev ?
      this.state.userProfilesPrev :
      this.state.userProfiles;
    const data = isPrev ? this.props.dataPrev : this.props.data;

    const reviewBars = data.map((week, i) => {
      const barValue = userProfiles[tab].weeklyData[i] || 0;

      return {
        name: `Wk${i + 1}`,
        value: barValue,
        valueFormatted: `${Math.floor(barValue * 100)}%`,
      };
    });
    return reviewBars;
  }

  render() {
    if (this.state.isLoaded) {
      const inactiveClasses = 'tab__title padding-bottom--micro';
      const imageClasses = 'padding-right--micro accordion__header__icon';

      return h(
          BasicCard,
          {
            id: this.props.id,
            className: this.props.className,
          },
          [
            h(
                h4,
                {
                  key: 'title__key',
                  className: 'card__title flex',
                },
                [
                  h(
                      Image,
                      {
                        key: 'image__key',
                        src: this.props.icon,
                        className: imageClasses,
                        srcSet: {
                          standard: this.props.icon,
                          retina: this.props.icon_2x,
                        },
                      },
                      null
                  ),
                  this.props.title,
                ]
            ),

            h(
                TooltipGroup,
                {
                  title: this.props.subtitleTooltip,
                },
                h(
                    eyebrow,
                    {
                      key: 'eyebrow__key',
                      className: 'padding-bottom--md',
                    },
                    this.props.subtitle
                )
            ),

          this.state.hasError ?
            h(
                ReportError,
                {
                  message: this.props.noDataError,
                },
                null
            ) :
            h('div', null, [
              h(
                  MobileMenu,
                  {
                    key: 'drive-user-profiles--mobile__menu',
                    id: 'drive-user-profiles--mobile__menu',
                    selectedIndex: this.state.activeTab,
                    anchorEl: this.state.mobileAnchorEl,
                    menuList: this.props.tabs,
                    handleMobileMenuOpen: this.handleMobileMenuOpen,
                    handleMobileMenuClose: this.handleMobileMenuClose,
                    changeContent: this.changeContent,
                  },
                  null
              ),
              h(
                  'div',
                  {
                    className: 'tabs',
                  },
                  [
                    h(
                        'div',
                        {
                          key: 'tabs__header',
                          className:
                          'flex--space-between tab__titles hide--mobile',
                        },
                        this.props.tabs.map((tab, i) => {
                          return h(
                              TabHeader,
                              {
                                i: i,
                                inactiveClasses,
                                handleTabClick: this.changeContent,
                                activeTab: this.state.activeTab,
                              },
                              h(
                                  TooltipGroup,
                                  {
                                    title: tab.tooltip,
                                  },
                                  h(caption, null, tab.title)
                              )
                          );
                        })
                    ),
                    h(
                        'div',
                        {
                          key: 'tabs__content',
                          id: 'drive-profiles__tabs',
                        },
                        this.props.tabs.map((tab, i) => {
                          return h(
                              DriveUserProfilesTabContent,
                              {
                                i: i,
                                id: tab.title.toLowerCase(),
                                activeTab: this.state.activeTab,
                                createReviewBars: this.createReviewBars,
                                parentId: 'drive-profiles__tabs',
                                dynamicGraphSize: this.props.dynamicGraphSize,
                                screenWidth: this.props.screenWidth,
                                chartName: this.props.chartName,
                                chartNamePrev: this.props.chartNamePrev,
                              },
                              null
                          );
                        })
                    ),
                  ]
              ),
            ]),
          ]
      );
    } else {
      return h(LoadingIndicator, null, null);
    }
  }
}

export default DriveUserProfiles;
